/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getObstetricEvents } from 'app/entities/obstetric-event/obstetric-event.reducer';
import { getEntities as getLaborIncidents } from 'app/entities/labor-incident/labor-incident.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { getEntities as getSpecialityVitals } from 'app/entities/speciality-vitals/speciality-vitals.reducer';
import { createEntity, getEntity, reset, updateEntity } from './labor-progression.reducer';

export const LaborProgressionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const obstetricEvents = useAppSelector(state => state.obstetricEvent.entities);
  const laborIncidents = useAppSelector(state => state.laborIncident.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const specialityVitals = useAppSelector(state => state.specialityVitals.entities);
  const laborProgressionEntity = useAppSelector(state => state.laborProgression.entity);
  const loading = useAppSelector(state => state.laborProgression.loading);
  const updating = useAppSelector(state => state.laborProgression.updating);
  const updateSuccess = useAppSelector(state => state.laborProgression.updateSuccess);

  const handleClose = () => {
    navigate(`/labor-progression${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getObstetricEvents({}));
    dispatch(getLaborIncidents({}));
    dispatch(getPregnancyCases({}));
    dispatch(getSpecialityVitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...laborProgressionEntity,
      ...values,
      obstetricEvent: obstetricEvents.find(it => it.id.toString() === values.obstetricEvent?.toString()),
      incident: laborIncidents.find(it => it.id.toString() === values.incident?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
      vital: specialityVitals.find(it => it.id.toString() === values.vital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...laborProgressionEntity,
          obstetricEvent: laborProgressionEntity?.obstetricEvent?.id,
          incident: laborProgressionEntity?.incident?.id,
          pregnancy: laborProgressionEntity?.pregnancy?.id,
          vital: laborProgressionEntity?.vital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.laborProgression.home.createOrEditLabel" data-cy="LaborProgressionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.laborProgression.home.createOrEditLabel">Create or edit a LaborProgression</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="labor-progression-id"
                  label={translate('tinyMedicRestApp.laborProgression.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.observation')}
                id="labor-progression-observation"
                name="observation"
                data-cy="observation"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.comments')}
                id="labor-progression-comments"
                name="comments"
                data-cy="comments"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.active')}
                id="labor-progression-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.cursor')}
                id="labor-progression-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.lastUpdated')}
                id="labor-progression-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.microSec')}
                id="labor-progression-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.timestampEntry')}
                id="labor-progression-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborProgression.expose')}
                id="labor-progression-expose"
                name="expose"
                data-cy="expose"
                check
                type="checkbox"
              />
              <ValidatedField
                id="labor-progression-obstetricEvent"
                name="obstetricEvent"
                data-cy="obstetricEvent"
                label={translate('tinyMedicRestApp.laborProgression.obstetricEvent')}
                type="select"
              >
                <option value="" key="0" />
                {obstetricEvents
                  ? obstetricEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-progression-incident"
                name="incident"
                data-cy="incident"
                label={translate('tinyMedicRestApp.laborProgression.incident')}
                type="select"
              >
                <option value="" key="0" />
                {laborIncidents
                  ? laborIncidents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-progression-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.laborProgression.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-progression-vital"
                name="vital"
                data-cy="vital"
                label={translate('tinyMedicRestApp.laborProgression.vital')}
                type="select"
              >
                <option value="" key="0" />
                {specialityVitals
                  ? specialityVitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/labor-progression" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LaborProgressionUpdate;
